<template>
  <div class="caretaker">
    <div class="my-4 border-dashed border border-gray-500 cursor-pointer rounded px-3 py-3 hover:border-red-300 hover:bg-red-100" v-bind:class="{'bg-pilke-primary text-white border-solid border-red-600 hover:bg-pilke-primary selected': selectedNeed('fulltime')}" v-on:click="storeState.need.option = 'fulltime'">Kokoaikainen</div>
    <div class="my-4 border-dashed border border-gray-500 cursor-pointer rounded px-3 py-3 hover:border-red-300 hover:bg-red-100" v-bind:class="{'bg-pilke-primary text-white border-solid border-red-600 hover:bg-pilke-primary selected': selectedNeed('parttime')}" v-on:click="storeState.need.option = 'parttime'">Osa-aikainen</div>

  </div>
</template>

<script>
export default {
   name: 'need',

   props: ['store'],

   components: {
   },

   data () {
      return {
         storeState: this.store.state
      }
   },

   methods: {
      selectedNeed (need) {
         return this.storeState.need.option === need
      }
   }
}
</script>

<style scoped>
.selected {
   @apply pl-12;
   background-image: url('../assets/checkmark.png');
   background-repeat: no-repeat;
   background-position: left 10px center;
}
</style>
